export default from './app';



// WEBPACK FOOTER //
// ./app/components/app/index.js